import { useEffect, useState } from "react";
import { Table, Input, Card, Empty, Button, Space } from "antd";
import { SearchOutlined, CloudSyncOutlined } from "@ant-design/icons";
import { searchVendorsPaged, syncVendors } from "../../services/vendorService";

const VendorList = () => {
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const isMobile = window.innerWidth < 768;

    const loadVendors = async (params = {}) => {
        try {
            setLoading(true);

            const { current, pageSize } = {
                ...pagination,
                ...params,
            };

            const result = await searchVendorsPaged({
                search: searchTerm,
                page: current,
                pageSize,
            });

            setVendors(result.data || []);

            setPagination((prev) => ({
                ...prev,
                current,
                pageSize,
                total: result.total || 0,
            }));
        } catch (error) {
            console.error("Error cargando vendedores:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSyncVendors = async () => {
        try {
            setLoading(true);
            await syncVendors();
            loadVendors({ current: 1 }); // recargar después de sync
            window.messageApi.success("Vendedores sincronizados correctamente");
        }
        catch (error) {
            const message = error?.response?.data?.message || error?.message || "Error durante la sincronización de vendedores.";
            window.messageApi.error("Error sincronizando vendedores: " + message);
        }
        finally {
            setLoading(false);
        }
    }

    // carga inicial
    useEffect(() => {
        loadVendors({ current: 1 });
    }, []);

    // recarga al buscar
    useEffect(() => {
        loadVendors({ current: 1 });
    }, [searchTerm]);

    const handleTableChange = (newPagination) => {
        loadVendors({
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    const columns = [
        {
            title: "Código",
            dataIndex: "value",
            key: "value",
        },
        {
            title: "Nombre",
            dataIndex: "label",
            key: "label",
        }
    ];

    return (
        <div className="client-list-container">
            <Card
                title="Vendedores"
                extra={
                    <Space>
                        <Button
                            icon={<CloudSyncOutlined />}
                            onClick={handleSyncVendors}
                            loading={loading}
                            type="primary"
                        >
                            {isMobile ? "" : "Sincronizar vendedores"}
                        </Button>
                    </Space>
                }
            >
                <div style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Buscar vendedores..."
                        prefix={<SearchOutlined />}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        allowClear
                        size="large"
                    />
                </div>

                {vendors.length === 0 && !loading ? (
                    <Empty description="No hay vendedores" />
                ) : (
                    <div className="client-table-wrapper">
                        <Table
                            rowKey="No"
                            columns={columns}
                            dataSource={vendors}
                            pagination={{
                                ...pagination,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                pageSizeOptions: ["5", "10", "20", "50"],
                                showTotal: (total, range) =>
                                    `${range[0]}-${range[1]} de ${total} elementos`,
                            }}
                            onChange={handleTableChange}
                            bordered
                            size="middle"
                            scroll={{
                                x: "max-content",
                            }}
                            loading={loading}
                        />
                    </div>
                )}
            </Card>
        </div>
    );
};

export default VendorList;